module.exports = __webpack_public_path__ + "assets/img/69f6540a105f4a7b12c4a966c03076e7.svg";